import { render, staticRenderFns } from "./HistoryFuel.vue?vue&type=template&id=4f5edbf2&"
import script from "./HistoryFuel.vue?vue&type=script&lang=js&"
export * from "./HistoryFuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "HistoryFuel.vue"
export default component.exports